var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMontenegro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0001C32 10.5088 29.2332 5.66415 25.0179 2.78271H6.98206C2.76687 5.66415 0 10.5088 0 16.0001C0 21.4915 2.76687 26.336 6.98206 29.2175H25.0179C29.2332 26.336 32 21.4915 32 16.0001Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5225 11.826H19.479V9.04341L18.0876 9.73904L16.0007 7.6521L13.9138 9.73904L12.5225 9.04341V11.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2611 15.9999H18.7842C18.9206 15.7641 18.9998 15.4911 18.9998 15.1991C18.9998 14.3124 18.281 13.5938 17.3944 13.5938C16.7819 13.5938 16.2499 13.937 15.9792 14.4414C15.7085 13.9369 15.1765 13.5938 14.5639 13.5938C13.6774 13.5938 12.9586 14.3124 12.9586 15.1991C12.9586 15.4912 13.0379 15.7641 13.1742 15.9999H9.73926C9.73926 17.0639 10.6659 17.9263 11.7298 17.9263H11.6657C11.6657 18.799 12.2461 19.5359 13.0419 19.7726L11.4784 21.3363L12.9541 22.8119L15.0474 20.7186C15.1294 20.7487 15.2142 20.7727 15.3019 20.7892L14.037 23.6451C14.6431 23.8916 15.3056 24.0284 16.0003 24.0284C16.6949 24.0284 17.3573 23.8916 17.9635 23.6451L16.6986 20.7892C16.7863 20.7727 16.8711 20.7487 16.953 20.7186L19.0463 22.8119L20.5219 21.3363L18.9583 19.7726C19.7541 19.5358 20.3346 18.7991 20.3346 17.9264H20.2704C21.3344 17.9263 22.2611 17.0639 22.2611 15.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.0435L13.7391 18.0869V20.1739L16 21.5651L18.2609 20.1739V18.0869L16 17.0435Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7391 16H18.2609V18.7826H13.7391V16Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMontenegro);
export default __webpack_public_path__ + "static/media/flag_montenegro.fc6877a9447a597ef230e4825a550f58.svg";
export { ForwardRef as ReactComponent };